import Vue from 'vue';
import i18n from '@/i18n';
const vue = new Vue({i18n});

export const ADMINISTRATOR = "ADMINISTRATOR";
export const NORMAL = "NORMAL";
export const LIMITED = "LIMITED";

export const TYPES_USER = [
    {id: ADMINISTRATOR, name: vue.$t('enumerations.type-user.administrator')},
    {id: NORMAL, name: vue.$t('enumerations.type-user.normal')},
    {id: LIMITED, name: vue.$t('enumerations.type-user.limited')},
];

export const _getTypeUserLabel = (typeUser) => {
    switch (typeUser) {
        case ADMINISTRATOR : return vue.$t('enumerations.type-user.administrator');
        case NORMAL : return vue.$t('enumerations.type-user.normal');
        case LIMITED : return vue.$t('enumerations.type-user.limited');
    }
}